//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAdminClient {
    /**
     * Get data connection options
     */
    getDatabaseOverview(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatabaseOverviewDto>;
}

export class AdminClient implements IAdminClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get data connection options
     */
    getDatabaseOverview( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatabaseOverviewDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatabaseOverview(_response);
        });
    }

    protected processGetDatabaseOverview(response: AxiosResponse): Promise<DatabaseOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatabaseOverviewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatabaseOverviewDto>(null as any);
    }
}

export interface ICodeListAttributeMappingClient {
    /**
     * Get the code list attribute mapping
     * @param modelId The unique id of the entity model
     */
    getCodeListAttributeMapping(modelId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CodeListAttributeMappingDto>;
    /**
     * Save the code list attribute mapping
     * @param modelId The unique id of the entity model
     * @param body the content to update
     * @return OK
     */
    save(modelId: number, body: SaveCodeListAttributeMappingDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class CodeListAttributeMappingClient implements ICodeListAttributeMappingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get the code list attribute mapping
     * @param modelId The unique id of the entity model
     */
    getCodeListAttributeMapping(modelId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CodeListAttributeMappingDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/codelistattributemapping/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodeListAttributeMapping(_response);
        });
    }

    protected processGetCodeListAttributeMapping(response: AxiosResponse): Promise<CodeListAttributeMappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<CodeListAttributeMappingDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CodeListAttributeMappingDto>(null as any);
    }

    /**
     * Save the code list attribute mapping
     * @param modelId The unique id of the entity model
     * @param body the content to update
     * @return OK
     */
    save(modelId: number, body: SaveCodeListAttributeMappingDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/codelistattributemapping/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDataConnectionClient {
    /**
     * Get data connection options
     */
    get(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DataConnectionDto[]>;
}

export class DataConnectionClient implements IDataConnectionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get data connection options
     */
    get( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DataConnectionDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/dataconnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DataConnectionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DataConnectionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataConnectionDto[]>(null as any);
    }
}

export interface IDeliveryEntityClient {
    /**
     * Get delivery entities by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryEntityDetailDto[]>;
    /**
     * Get delivery entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryEntityDetailDto[]>;
    /**
     * Create a delivery entity
     * @param body the content to create
     * @return OK
     */
    create(body: CreateDeliveryEntityDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update a delivery entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliveryEntityDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a delivery entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class DeliveryEntityClient implements IDeliveryEntityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get delivery entities by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentity/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<DeliveryEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryEntityDetailDto[]>(null as any);
    }

    /**
     * Get delivery entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentity/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<DeliveryEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryEntityDetailDto[]>(null as any);
    }

    /**
     * Create a delivery entity
     * @param body the content to create
     * @return OK
     */
    create(body: CreateDeliveryEntityDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update a delivery entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliveryEntityDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a delivery entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDeliveryEntityLinkClient {
    /**
     * Get delivery entity links by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryEntityLinkDetailDto[]>;
    /**
     * Create a new entity link
     * @param dto The body of the created link
     */
    createEntityLink(dto: DeliveryEntityLinkCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryEntityLinkDetailDto[]>;
    /**
     * Update the entity Entity mapping
     * @param id The unique identifier of the entitylink
     * @param dto The body of the updated Entitylink
     */
    updateEntityLink(id: number, dto: DeliveryEntityLinkUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete the entity Entity mapping
     * @param entityLinkId The unique identifier of the entitylink
     */
    deleteEntityLink(entityLinkId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class DeliveryEntityLinkClient implements IDeliveryEntityLinkClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get delivery entity links by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryEntityLinkDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentitylink/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<DeliveryEntityLinkDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryEntityLinkDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryEntityLinkDetailDto[]>(null as any);
    }

    /**
     * Create a new entity link
     * @param dto The body of the created link
     */
    createEntityLink(dto: DeliveryEntityLinkCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryEntityLinkDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentitylink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEntityLink(_response);
        });
    }

    protected processCreateEntityLink(response: AxiosResponse): Promise<DeliveryEntityLinkDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<DeliveryEntityLinkDetailDto[]>(result201);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryEntityLinkDetailDto[]>(null as any);
    }

    /**
     * Update the entity Entity mapping
     * @param id The unique identifier of the entitylink
     * @param dto The body of the updated Entitylink
     */
    updateEntityLink(id: number, dto: DeliveryEntityLinkUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentitylink/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEntityLink(_response);
        });
    }

    protected processUpdateEntityLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the entity Entity mapping
     * @param entityLinkId The unique identifier of the entitylink
     */
    deleteEntityLink(entityLinkId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryentitylink/{entityLinkId}";
        if (entityLinkId === undefined || entityLinkId === null)
            throw new globalThis.Error("The parameter 'entityLinkId' must be defined.");
        url_ = url_.replace("{entityLinkId}", encodeURIComponent("" + entityLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEntityLink(_response);
        });
    }

    protected processDeleteEntityLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDeliveryProcessDefinitionClient {
    /**
     * Get all delivery process definitions
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinitionSearchResultDto[]>;
    /**
     * Search for delivery process definitions
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param organisation (optional) 
     * @param ovoNumber (optional) 
     * @param statusType (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, organisation?: string | null | undefined, ovoNumber?: string | null | undefined, statusType?: string | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfDeliveryProcessDefinitionSearchResultDto>;
    /**
     * Get delivery process definition by id
     * @param id The unique id
     */
    getDetail(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinitionDetailDto>;
    /**
     * Update a delivery process definition
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliveryProcessDefinitionDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a delivery process definition
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Create a delivery process definition
     * @param body the content to update
     * @return OK
     */
    create(body: CreateDeliveryProcessDefinitionDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Change status of a delivery process definition
     * @param id the unique id
     * @param statusType (optional) the status type
     * @return OK
     */
    changeStatus(id: number, statusType?: string | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Duplicate a delivery process definition
     * @param id the unique id
     * @param options the duplication options
     * @return OK
     */
    duplicate(id: number, options: DeliveryProcessDefinitionDuplicationOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Import a delivery process definition
     * @param parentDefinitionId (optional) 
     * @param file (optional) 
     * @return OK
     */
    import(parentDefinitionId?: number | null | undefined, file?: FileParameter | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Export a delivery process definition
     * @param id the unique id
     * @return OK
     */
    export(id: number, exportOptions: DeliveryProcessDefinitionExportOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Cascade delete an delivery process definition
     * @param id the unique id
     */
    cascadeDelete(id: number, cascadeDeleteOptions: DeliveryProcessDefinitionCascadeDeleteOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get dependencies report of a delivery process definition
     * @param id the unique id
     */
    getDependenciesReport(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinitionDependenciesReportDto>;
    /**
     * Validate cascade delete of an delivery process definition
     * @param id the unique id
     */
    cascadeDeleteValidate(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<boolean>;
    /**
     * Generate a delivery process definition report.
     * @param id the unique id
     * @return OK
     */
    generateReport(id: number, reportingOptions: DeliveryProcessDefinitionReportingOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Get a delivery process definition report.
     * @param id the unique id
     * @return OK
     */
    getReport(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Import a specification into the delivery process definition
     * @param id the delivery process definition id
     * @param importSpecificationDto the specification to import
     * @return OK
     */
    importSpecification(id: number, importSpecificationDto: ImportSpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ImportSpecificationResultDto>;
}

export class DeliveryProcessDefinitionClient implements IDeliveryProcessDefinitionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all delivery process definitions
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinitionSearchResultDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DeliveryProcessDefinitionSearchResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryProcessDefinitionSearchResultDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryProcessDefinitionSearchResultDto[]>(null as any);
    }

    /**
     * Search for delivery process definitions
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param organisation (optional) 
     * @param ovoNumber (optional) 
     * @param statusType (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, organisation?: string | null | undefined, ovoNumber?: string | null | undefined, statusType?: string | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfDeliveryProcessDefinitionSearchResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (organisation !== undefined && organisation !== null)
            url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
        if (ovoNumber !== undefined && ovoNumber !== null)
            url_ += "ovoNumber=" + encodeURIComponent("" + ovoNumber) + "&";
        if (statusType !== undefined && statusType !== null)
            url_ += "statusType=" + encodeURIComponent("" + statusType) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfDeliveryProcessDefinitionSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfDeliveryProcessDefinitionSearchResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfDeliveryProcessDefinitionSearchResultDto>(null as any);
    }

    /**
     * Get delivery process definition by id
     * @param id The unique id
     */
    getDetail(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinitionDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<DeliveryProcessDefinitionDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryProcessDefinitionDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryProcessDefinitionDetailDto>(null as any);
    }

    /**
     * Update a delivery process definition
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliveryProcessDefinitionDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a delivery process definition
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a delivery process definition
     * @param body the content to update
     * @return OK
     */
    create(body: CreateDeliveryProcessDefinitionDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Change status of a delivery process definition
     * @param id the unique id
     * @param statusType (optional) the status type
     * @return OK
     */
    changeStatus(id: number, statusType?: string | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/status?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (statusType === null)
            throw new globalThis.Error("The parameter 'statusType' cannot be null.");
        else if (statusType !== undefined)
            url_ += "statusType=" + encodeURIComponent("" + statusType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeStatus(_response);
        });
    }

    protected processChangeStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Duplicate a delivery process definition
     * @param id the unique id
     * @param options the duplication options
     * @return OK
     */
    duplicate(id: number, options: DeliveryProcessDefinitionDuplicationOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/duplicate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Import a delivery process definition
     * @param parentDefinitionId (optional) 
     * @param file (optional) 
     * @return OK
     */
    import(parentDefinitionId?: number | null | undefined, file?: FileParameter | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/import?";
        if (parentDefinitionId !== undefined && parentDefinitionId !== null)
            url_ += "parentDefinitionId=" + encodeURIComponent("" + parentDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Export a delivery process definition
     * @param id the unique id
     * @return OK
     */
    export(id: number, exportOptions: DeliveryProcessDefinitionExportOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/export";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Cascade delete an delivery process definition
     * @param id the unique id
     */
    cascadeDelete(id: number, cascadeDeleteOptions: DeliveryProcessDefinitionCascadeDeleteOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/cascade-delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cascadeDeleteOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCascadeDelete(_response);
        });
    }

    protected processCascadeDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get dependencies report of a delivery process definition
     * @param id the unique id
     */
    getDependenciesReport(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryProcessDefinitionDependenciesReportDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/dependencies/report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDependenciesReport(_response);
        });
    }

    protected processGetDependenciesReport(response: AxiosResponse): Promise<DeliveryProcessDefinitionDependenciesReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryProcessDefinitionDependenciesReportDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryProcessDefinitionDependenciesReportDto>(null as any);
    }

    /**
     * Validate cascade delete of an delivery process definition
     * @param id the unique id
     */
    cascadeDeleteValidate(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/cascade-delete/validate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCascadeDeleteValidate(_response);
        });
    }

    protected processCascadeDeleteValidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Generate a delivery process definition report.
     * @param id the unique id
     * @return OK
     */
    generateReport(id: number, reportingOptions: DeliveryProcessDefinitionReportingOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/generate-report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportingOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateReport(_response);
        });
    }

    protected processGenerateReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get a delivery process definition report.
     * @param id the unique id
     * @return OK
     */
    getReport(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Import a specification into the delivery process definition
     * @param id the delivery process definition id
     * @param importSpecificationDto the specification to import
     * @return OK
     */
    importSpecification(id: number, importSpecificationDto: ImportSpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ImportSpecificationResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryprocessdefinition/{id}/import-specification";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importSpecificationDto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportSpecification(_response);
        });
    }

    protected processImportSpecification(response: AxiosResponse): Promise<ImportSpecificationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<ImportSpecificationResultDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportSpecificationResultDto>(null as any);
    }
}

export interface IDeliveryQualityCheckClient {
    /**
     * Get delivery quality checks by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryQualityCheckDetailDto[]>;
    /**
     * Save a delivery quality check for basic tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    saveBasicQualityCheck(specificationId: number, body: SaveBasicQualityCheckDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Save a delivery quality check status for existing standard tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    saveStandardQualityCheckStatus(specificationId: number, body: SaveStandardQualityCheckStatusDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Insert a delivery quality check for standard tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    insertStandardQualityCheck(specificationId: number, body: SaveStandardQualityCheckDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Update a delivery quality check for standard tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    updateStandardQualityCheck(specificationId: number, body: SaveStandardQualityCheckDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a delivery quality check
     * @param specificationId the specification id
     * @param body the content to delete
     * @return OK
     */
    delete(specificationId: number, body: DeleteQualityCheckDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class DeliveryQualityCheckClient implements IDeliveryQualityCheckClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get delivery quality checks by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryQualityCheckDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryqualitycheck/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<DeliveryQualityCheckDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryQualityCheckDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryQualityCheckDetailDto[]>(null as any);
    }

    /**
     * Save a delivery quality check for basic tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    saveBasicQualityCheck(specificationId: number, body: SaveBasicQualityCheckDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryqualitycheck/save-basic/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBasicQualityCheck(_response);
        });
    }

    protected processSaveBasicQualityCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Save a delivery quality check status for existing standard tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    saveStandardQualityCheckStatus(specificationId: number, body: SaveStandardQualityCheckStatusDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryqualitycheck/save-standard/status/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveStandardQualityCheckStatus(_response);
        });
    }

    protected processSaveStandardQualityCheckStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Insert a delivery quality check for standard tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    insertStandardQualityCheck(specificationId: number, body: SaveStandardQualityCheckDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryqualitycheck/insert-standard/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertStandardQualityCheck(_response);
        });
    }

    protected processInsertStandardQualityCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update a delivery quality check for standard tests
     * @param specificationId the specification id
     * @param body the content to save
     * @return OK
     */
    updateStandardQualityCheck(specificationId: number, body: SaveStandardQualityCheckDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryqualitycheck/update-standard/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStandardQualityCheck(_response);
        });
    }

    protected processUpdateStandardQualityCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a delivery quality check
     * @param specificationId the specification id
     * @param body the content to delete
     * @return OK
     */
    delete(specificationId: number, body: DeleteQualityCheckDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryqualitycheck/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDeliverySpecificationClient {
    /**
     * Search for delivery specifications
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param definitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfSearchDeliverySpecificationDto>;
    /**
     * Get delivery specifications by id
     * @param id The unique definitionId
     */
    getById(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliverySpecificationDetailDto>;
    /**
     * Update a delivery specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliverySpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Partial Update a delivery specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    partialUpdate(id: number, body: PartialUpdateDeliverySpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a delivery Specifiation
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get delivery specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliverySpecificationDetailDto[]>;
    /**
     * Create a delivery process specification
     * @param body the content to create
     * @return OK
     */
    create(body: CreateDeliverySpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
}

export class DeliverySpecificationClient implements IDeliverySpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for delivery specifications
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param definitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfSearchDeliverySpecificationDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (definitionId !== undefined && definitionId !== null)
            url_ += "definitionId=" + encodeURIComponent("" + definitionId) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfSearchDeliverySpecificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfSearchDeliverySpecificationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfSearchDeliverySpecificationDto>(null as any);
    }

    /**
     * Get delivery specifications by id
     * @param id The unique definitionId
     */
    getById(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliverySpecificationDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DeliverySpecificationDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliverySpecificationDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliverySpecificationDetailDto>(null as any);
    }

    /**
     * Update a delivery specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliverySpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Partial Update a delivery specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    partialUpdate(id: number, body: PartialUpdateDeliverySpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartialUpdate(_response);
        });
    }

    protected processPartialUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a delivery Specifiation
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get delivery specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliverySpecificationDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<DeliverySpecificationDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliverySpecificationDetailDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliverySpecificationDetailDto[]>(null as any);
    }

    /**
     * Create a delivery process specification
     * @param body the content to create
     * @return OK
     */
    create(body: CreateDeliverySpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliveryspecification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }
}

export interface IDeliveryTransformationClient {
    /**
     * Get delivery transformations by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DeliveryTransformationDetailDto[]>;
    /**
     * Create a delivery transformation
     * @param body the content to create
     * @return OK
     */
    create(body: CreateDeliveryTransformationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update a delivery transformation
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliveryTransformationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a delivery transformation
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class DeliveryTransformationClient implements IDeliveryTransformationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get delivery transformations by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DeliveryTransformationDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliverytransformation/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<DeliveryTransformationDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DeliveryTransformationDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryTransformationDetailDto[]>(null as any);
    }

    /**
     * Create a delivery transformation
     * @param body the content to create
     * @return OK
     */
    create(body: CreateDeliveryTransformationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliverytransformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update a delivery transformation
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateDeliveryTransformationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliverytransformation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a delivery transformation
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/deliverytransformation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEntityAttributeClient {
    /**
     * Get entity attributes by model id
     */
    getByModel(modelId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<EntityAttributeDetailDto[]>;
    /**
     * Create an entity attribute
     * @param body the attributes of the entity attribute
     * @return OK
     */
    create(body: CreateEntityAttributeDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update an entity attribute
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateEntityAttributeDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete an entity attribute
     * @param id the unique id
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class EntityAttributeClient implements IEntityAttributeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get entity attributes by model id
     */
    getByModel(modelId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<EntityAttributeDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entityattribute/getbymodel/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByModel(_response);
        });
    }

    protected processGetByModel(response: AxiosResponse): Promise<EntityAttributeDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<EntityAttributeDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityAttributeDetailDto[]>(null as any);
    }

    /**
     * Create an entity attribute
     * @param body the attributes of the entity attribute
     * @return OK
     */
    create(body: CreateEntityAttributeDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entityattribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update an entity attribute
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateEntityAttributeDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entityattribute/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an entity attribute
     * @param id the unique id
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entityattribute/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEntityModelClient {
    /**
     * Search for entity models
     * @param id (optional) 
     * @param code (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param contextType (optional) 
     * @param entityType (optional) 
     * @param hasHistory (optional) 
     * @param statusType (optional) 
     * @param deliveryProcessDefinitionId (optional) 
     * @param productProcessDefinitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, code?: string | null | undefined, label?: string | null | undefined, description?: string | null | undefined, contextType?: string | null | undefined, entityType?: string | null | undefined, hasHistory?: boolean | null | undefined, statusType?: string | null | undefined, deliveryProcessDefinitionId?: number | null | undefined, productProcessDefinitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfSearchEntityModelDto>;
    searchAll(contextType?: string | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SearchEntityModelDto[]>;
    /**
     * Get entity model by id
     * @param id The unique id
     */
    getDetail(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<EntityModelDetailDto>;
    /**
     * Update an entity model
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateEntityModelDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete an entity model
     * @param id the unique id
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Create an entity model
     * @param body the content to update
     * @return OK
     */
    create(body: CreateEntityModelDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Change status of an entity model
     * @param id the unique id
     * @param statusType (optional) the status type
     * @return OK
     */
    changeStatus(id: number, statusType?: string | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Duplicate an entity model
     * @param id the unique id
     * @return OK
     */
    duplicate(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Import an entity model
     * @param file (optional) 
     * @return OK
     */
    import(file?: FileParameter | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Export an entity model
     * @param id the unique id
     * @return OK
     */
    export(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Cascade delete an entity model
     * @param id the unique id
     */
    cascadeDelete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get dependencies report of an entity model
     * @param id the unique id
     */
    getDependenciesReport(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<EntityModelDependenciesReportDto>;
    /**
     * Validate cascade delete of an entity model
     * @param id the unique id
     */
    cascadeDeleteValidate(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<boolean>;
}

export class EntityModelClient implements IEntityModelClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for entity models
     * @param id (optional) 
     * @param code (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param contextType (optional) 
     * @param entityType (optional) 
     * @param hasHistory (optional) 
     * @param statusType (optional) 
     * @param deliveryProcessDefinitionId (optional) 
     * @param productProcessDefinitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, code?: string | null | undefined, label?: string | null | undefined, description?: string | null | undefined, contextType?: string | null | undefined, entityType?: string | null | undefined, hasHistory?: boolean | null | undefined, statusType?: string | null | undefined, deliveryProcessDefinitionId?: number | null | undefined, productProcessDefinitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfSearchEntityModelDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (contextType !== undefined && contextType !== null)
            url_ += "contextType=" + encodeURIComponent("" + contextType) + "&";
        if (entityType !== undefined && entityType !== null)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (hasHistory !== undefined && hasHistory !== null)
            url_ += "hasHistory=" + encodeURIComponent("" + hasHistory) + "&";
        if (statusType !== undefined && statusType !== null)
            url_ += "statusType=" + encodeURIComponent("" + statusType) + "&";
        if (deliveryProcessDefinitionId !== undefined && deliveryProcessDefinitionId !== null)
            url_ += "deliveryProcessDefinitionId=" + encodeURIComponent("" + deliveryProcessDefinitionId) + "&";
        if (productProcessDefinitionId !== undefined && productProcessDefinitionId !== null)
            url_ += "productProcessDefinitionId=" + encodeURIComponent("" + productProcessDefinitionId) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfSearchEntityModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfSearchEntityModelDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfSearchEntityModelDto>(null as any);
    }

    searchAll(contextType?: string | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SearchEntityModelDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/searchall?";
        if (contextType !== undefined && contextType !== null)
            url_ += "contextType=" + encodeURIComponent("" + contextType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAll(_response);
        });
    }

    protected processSearchAll(response: AxiosResponse): Promise<SearchEntityModelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SearchEntityModelDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchEntityModelDto[]>(null as any);
    }

    /**
     * Get entity model by id
     * @param id The unique id
     */
    getDetail(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<EntityModelDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<EntityModelDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<EntityModelDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModelDetailDto>(null as any);
    }

    /**
     * Update an entity model
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateEntityModelDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an entity model
     * @param id the unique id
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create an entity model
     * @param body the content to update
     * @return OK
     */
    create(body: CreateEntityModelDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Change status of an entity model
     * @param id the unique id
     * @param statusType (optional) the status type
     * @return OK
     */
    changeStatus(id: number, statusType?: string | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}/status?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (statusType === null)
            throw new globalThis.Error("The parameter 'statusType' cannot be null.");
        else if (statusType !== undefined)
            url_ += "statusType=" + encodeURIComponent("" + statusType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeStatus(_response);
        });
    }

    protected processChangeStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Duplicate an entity model
     * @param id the unique id
     * @return OK
     */
    duplicate(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}/duplicate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Import an entity model
     * @param file (optional) 
     * @return OK
     */
    import(file?: FileParameter | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Export an entity model
     * @param id the unique id
     * @return OK
     */
    export(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}/export";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Cascade delete an entity model
     * @param id the unique id
     */
    cascadeDelete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}/cascade-delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCascadeDelete(_response);
        });
    }

    protected processCascadeDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get dependencies report of an entity model
     * @param id the unique id
     */
    getDependenciesReport(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<EntityModelDependenciesReportDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}/dependencies/report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDependenciesReport(_response);
        });
    }

    protected processGetDependenciesReport(response: AxiosResponse): Promise<EntityModelDependenciesReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<EntityModelDependenciesReportDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityModelDependenciesReportDto>(null as any);
    }

    /**
     * Validate cascade delete of an entity model
     * @param id the unique id
     */
    cascadeDeleteValidate(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/api/v1/entitymodel/{id}/cascade-delete/validate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCascadeDeleteValidate(_response);
        });
    }

    protected processCascadeDeleteValidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IGeckoSpecificationClient {
    /**
     * Search for a Gecko Specification by its unique specification code.
     * @param specificationCode the unique specification code
     * @return OK
     */
    search(specificationCode: string, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<GeckoSpecificationSearchResultDto>;
}

export class GeckoSpecificationClient implements IGeckoSpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for a Gecko Specification by its unique specification code.
     * @param specificationCode the unique specification code
     * @return OK
     */
    search(specificationCode: string , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<GeckoSpecificationSearchResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/geckospecification/search/{specificationCode}";
        if (specificationCode === undefined || specificationCode === null)
            throw new globalThis.Error("The parameter 'specificationCode' must be defined.");
        url_ = url_.replace("{specificationCode}", encodeURIComponent("" + specificationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<GeckoSpecificationSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<GeckoSpecificationSearchResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeckoSpecificationSearchResultDto>(null as any);
    }
}

export interface IGeckoSynchronisationClient {
    /**
     * Export a delivery process definition for Gecko Sync
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    geckoExport(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Syncs a delivery process definition to Gecko
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    geckoSync(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get default tests for a delivery process definition for Gecko Sync
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    getGeckoDefaultTests(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<GeckoTestDto[]>;
    /**
     * Get standard tests for a delivery process definition for Gecko Sync
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    getGeckoStandardTests(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<GeckoTestDto[]>;
    /**
     * Get standard test types for gecko.
     * @param x_version (optional) 
     * @return OK
     */
    getGeckoStandardTestTypes(x_version?: string | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<GeckoStandardTestTypeDto[]>;
}

export class GeckoSynchronisationClient implements IGeckoSynchronisationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Export a delivery process definition for Gecko Sync
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    geckoExport(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/geckosynchronisation/{id}/gecko/export";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeckoExport(_response);
        });
    }

    protected processGeckoExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Syncs a delivery process definition to Gecko
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    geckoSync(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/geckosynchronisation/{id}/gecko/synchronise";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeckoSync(_response);
        });
    }

    protected processGeckoSync(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get default tests for a delivery process definition for Gecko Sync
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    getGeckoDefaultTests(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<GeckoTestDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/geckosynchronisation/{id}/gecko/default-tests";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeckoDefaultTests(_response);
        });
    }

    protected processGetGeckoDefaultTests(response: AxiosResponse): Promise<GeckoTestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<GeckoTestDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeckoTestDto[]>(null as any);
    }

    /**
     * Get standard tests for a delivery process definition for Gecko Sync
     * @param id the unique id of the delivery process definition
     * @return OK
     */
    getGeckoStandardTests(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<GeckoTestDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/geckosynchronisation/{id}/gecko/standard-tests";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeckoStandardTests(_response);
        });
    }

    protected processGetGeckoStandardTests(response: AxiosResponse): Promise<GeckoTestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<GeckoTestDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeckoTestDto[]>(null as any);
    }

    /**
     * Get standard test types for gecko.
     * @param x_version (optional) 
     * @return OK
     */
    getGeckoStandardTestTypes(x_version?: string | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<GeckoStandardTestTypeDto[]> {
        let url_ = this.baseUrl + "/gecko/standard-test-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "x-version": x_version !== undefined && x_version !== null ? "" + x_version : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeckoStandardTestTypes(_response);
        });
    }

    protected processGetGeckoStandardTestTypes(response: AxiosResponse): Promise<GeckoStandardTestTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<GeckoStandardTestTypeDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeckoStandardTestTypeDto[]>(null as any);
    }
}

export interface IOperationEntityClient {
    /**
     * Get operation entities by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<OperationEntityDetailDto[]>;
    /**
     * Get operation entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<OperationEntityDetailDto[]>;
    /**
     * Create an operation entity
     * @param body the content to create
     * @return OK
     */
    create(body: CreateOperationEntityDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update an operation entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateOperationEntityDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete an operation entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class OperationEntityClient implements IOperationEntityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get operation entities by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<OperationEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentity/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<OperationEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<OperationEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationEntityDetailDto[]>(null as any);
    }

    /**
     * Get operation entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<OperationEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentity/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<OperationEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<OperationEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationEntityDetailDto[]>(null as any);
    }

    /**
     * Create an operation entity
     * @param body the content to create
     * @return OK
     */
    create(body: CreateOperationEntityDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update an operation entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateOperationEntityDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an operation entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOperationEntityDataMappingClient {
    /**
     * Get operation entity data mappings by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<OperationEntityDataMappingDetailDto[]>;
    /**
     * Create an operation entity data mapping
     * @param body the content to create
     * @return OK
     */
    create(body: CreateOperationEntityDataMappingDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update an operation entity data mapping
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateOperationEntityDataMappingDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete an operation entity data mapping
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Generate operation entity data mappings by definition
     * @param definitionId The id of the delivery process definition
     */
    generateByDefinitionId(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Clears the operation entity data mappings by definition
     * @param definitionId The id of the delivery process definition
     */
    clearByDefinitionId(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class OperationEntityDataMappingClient implements IOperationEntityDataMappingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get operation entity data mappings by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<OperationEntityDataMappingDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentitydatamapping/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<OperationEntityDataMappingDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<OperationEntityDataMappingDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationEntityDataMappingDetailDto[]>(null as any);
    }

    /**
     * Create an operation entity data mapping
     * @param body the content to create
     * @return OK
     */
    create(body: CreateOperationEntityDataMappingDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentitydatamapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update an operation entity data mapping
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateOperationEntityDataMappingDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentitydatamapping/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an operation entity data mapping
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentitydatamapping/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Generate operation entity data mappings by definition
     * @param definitionId The id of the delivery process definition
     */
    generateByDefinitionId(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentitydatamapping/{definitionId}/generate";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateByDefinitionId(_response);
        });
    }

    protected processGenerateByDefinitionId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Clears the operation entity data mappings by definition
     * @param definitionId The id of the delivery process definition
     */
    clearByDefinitionId(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationentitydatamapping/{definitionId}/clear";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearByDefinitionId(_response);
        });
    }

    protected processClearByDefinitionId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOperationSpecificationClient {
    /**
     * Get operation specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<OperationSpecificationDetailDto[]>;
    /**
     * Create an operation specification
     * @param body the content to create
     * @return OK
     */
    create(body: CreateOperationSpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update an operation specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateOperationSpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete an operation specification
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Has unique schema for an operation specification
     * @param schema (optional) The schema search string
     * @return OK
     */
    hasUniqueSchema(schema?: string | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<boolean | null>;
}

export class OperationSpecificationClient implements IOperationSpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get operation specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<OperationSpecificationDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationspecification/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<OperationSpecificationDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<OperationSpecificationDetailDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationSpecificationDetailDto[]>(null as any);
    }

    /**
     * Create an operation specification
     * @param body the content to create
     * @return OK
     */
    create(body: CreateOperationSpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationspecification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update an operation specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateOperationSpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an operation specification
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Has unique schema for an operation specification
     * @param schema (optional) The schema search string
     * @return OK
     */
    hasUniqueSchema(schema?: string | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<boolean | null> {
        let url_ = this.baseUrl + "/backoffice/api/v1/operationspecification/has-unique-schema?";
        if (schema === null)
            throw new globalThis.Error("The parameter 'schema' cannot be null.");
        else if (schema !== undefined)
            url_ += "schema=" + encodeURIComponent("" + schema) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasUniqueSchema(_response);
        });
    }

    protected processHasUniqueSchema(response: AxiosResponse): Promise<boolean | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<boolean | null>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean | null>(null as any);
    }
}

export interface IOrganisationClient {
    /**
     * Search for organisations
     * @param id (optional) 
     * @param name (optional) 
     * @param kboNumber (optional) 
     * @param ovoNumber (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, name?: string | null | undefined, kboNumber?: string | null | undefined, ovoNumber?: string | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfOrganisationSearchResultDto>;
    /**
     * Get organisation detail
     */
    getDetail(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<OrganisationDetailDto>;
    /**
     * Update organisation
     */
    update(id: number, body: UpdateOrganisationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete organisation
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Create organisation
     */
    create(body: CreateOrganisationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
}

export class OrganisationClient implements IOrganisationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for organisations
     * @param id (optional) 
     * @param name (optional) 
     * @param kboNumber (optional) 
     * @param ovoNumber (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, name?: string | null | undefined, kboNumber?: string | null | undefined, ovoNumber?: string | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfOrganisationSearchResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/organisation/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kboNumber !== undefined && kboNumber !== null)
            url_ += "kboNumber=" + encodeURIComponent("" + kboNumber) + "&";
        if (ovoNumber !== undefined && ovoNumber !== null)
            url_ += "ovoNumber=" + encodeURIComponent("" + ovoNumber) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfOrganisationSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfOrganisationSearchResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfOrganisationSearchResultDto>(null as any);
    }

    /**
     * Get organisation detail
     */
    getDetail(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<OrganisationDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/organisation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<OrganisationDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<OrganisationDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationDetailDto>(null as any);
    }

    /**
     * Update organisation
     */
    update(id: number, body: UpdateOrganisationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/organisation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete organisation
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/organisation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create organisation
     */
    create(body: CreateOrganisationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/organisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }
}

export interface IPdfLicenseClient {
    getPdfLicenseInfo(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<PdfLicenseInfo[]>;
}

export class PdfLicenseClient implements IPdfLicenseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    getPdfLicenseInfo( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<PdfLicenseInfo[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/pdflicense";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdfLicenseInfo(_response);
        });
    }

    protected processGetPdfLicenseInfo(response: AxiosResponse): Promise<PdfLicenseInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<PdfLicenseInfo[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfLicenseInfo[]>(null as any);
    }
}

export interface IProcessTriggerClient {
    /**
     * Search for process triggers
     * @param id (optional) 
     * @param triggerType (optional) 
     * @param description (optional) 
     * @param deliveryProcessDefinitionId (optional) 
     * @param productProcessDefinitionId (optional) 
     * @param isEnabled (optional) 
     * @param organisationId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, triggerType?: string | null | undefined, description?: string | null | undefined, deliveryProcessDefinitionId?: number | null | undefined, productProcessDefinitionId?: number | null | undefined, isEnabled?: boolean | null | undefined, organisationId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfProcessTriggerSearchResultDto>;
    /**
     * Get process trigger detail
     */
    getDetail(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProcessTriggerDetailDto>;
    /**
     * Update process trigger
     */
    update(id: number, body: UpdateProcessTriggerDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete process trigger
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Create process trigger
     */
    create(body: CreateProcessTriggerDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Start a process trigger by hand, without waiting for its schedule
     */
    execute(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Whether a process trigger is busy at this moment, to be polled while the detail screen is open
     */
    getStatus(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProcessTriggerStatusDto>;
    /**
     * Get description of cron schedule
     * @param cronSchedule (optional) 
     */
    getDescription(cronSchedule?: string | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<string>;
}

export class ProcessTriggerClient implements IProcessTriggerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for process triggers
     * @param id (optional) 
     * @param triggerType (optional) 
     * @param description (optional) 
     * @param deliveryProcessDefinitionId (optional) 
     * @param productProcessDefinitionId (optional) 
     * @param isEnabled (optional) 
     * @param organisationId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, triggerType?: string | null | undefined, description?: string | null | undefined, deliveryProcessDefinitionId?: number | null | undefined, productProcessDefinitionId?: number | null | undefined, isEnabled?: boolean | null | undefined, organisationId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfProcessTriggerSearchResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (triggerType !== undefined && triggerType !== null)
            url_ += "triggerType=" + encodeURIComponent("" + triggerType) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (deliveryProcessDefinitionId !== undefined && deliveryProcessDefinitionId !== null)
            url_ += "deliveryProcessDefinitionId=" + encodeURIComponent("" + deliveryProcessDefinitionId) + "&";
        if (productProcessDefinitionId !== undefined && productProcessDefinitionId !== null)
            url_ += "productProcessDefinitionId=" + encodeURIComponent("" + productProcessDefinitionId) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfProcessTriggerSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfProcessTriggerSearchResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfProcessTriggerSearchResultDto>(null as any);
    }

    /**
     * Get process trigger detail
     */
    getDetail(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessTriggerDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<ProcessTriggerDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProcessTriggerDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessTriggerDetailDto>(null as any);
    }

    /**
     * Update process trigger
     */
    update(id: number, body: UpdateProcessTriggerDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete process trigger
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create process trigger
     */
    create(body: CreateProcessTriggerDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Start a process trigger by hand, without waiting for its schedule
     */
    execute(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/{id}/execute";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecute(_response);
        });
    }

    protected processExecute(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Whether a process trigger is busy at this moment, to be polled while the detail screen is open
     */
    getStatus(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessTriggerStatusDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<ProcessTriggerStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProcessTriggerStatusDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessTriggerStatusDto>(null as any);
    }

    /**
     * Get description of cron schedule
     * @param cronSchedule (optional) 
     */
    getDescription(cronSchedule?: string | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/api/v1/processtrigger/description?";
        if (cronSchedule === null)
            throw new globalThis.Error("The parameter 'cronSchedule' cannot be null.");
        else if (cronSchedule !== undefined)
            url_ += "cronSchedule=" + encodeURIComponent("" + cronSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDescription(_response);
        });
    }

    protected processGetDescription(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IProductEntityClient {
    /**
     * Get product entities by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductEntityDetailDto[]>;
    /**
     * Get product entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductEntityDetailDto[]>;
    /**
     * Create a product entity
     * @param body the content to create
     * @return OK
     */
    create(body: CreateProductEntityDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update a product entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateProductEntityDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a product entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class ProductEntityClient implements IProductEntityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get product entities by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentity/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<ProductEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntityDetailDto[]>(null as any);
    }

    /**
     * Get product entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentity/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<ProductEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntityDetailDto[]>(null as any);
    }

    /**
     * Create a product entity
     * @param body the content to create
     * @return OK
     */
    create(body: CreateProductEntityDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update a product entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateProductEntityDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a product entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProductEntityDataMappingClient {
    /**
     * Get product entity data mappings by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductEntityDataMappingDetailDto[]>;
    /**
     * Create an product entity data mapping
     * @param body the content to create
     * @return OK
     */
    create(body: CreateProductEntityDataMappingDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update an product entity data mapping
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateProductEntityDataMappingDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete an product entity data mapping
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Generate product entity data mappings by definition
     * @param definitionId The id of the product process definition
     */
    generateByDefinitionId(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Clears the product entity data mappings by definition
     * @param definitionId The id of the product process definition
     */
    clearByDefinitionId(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class ProductEntityDataMappingClient implements IProductEntityDataMappingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get product entity data mappings by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductEntityDataMappingDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitydatamapping/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<ProductEntityDataMappingDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductEntityDataMappingDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntityDataMappingDetailDto[]>(null as any);
    }

    /**
     * Create an product entity data mapping
     * @param body the content to create
     * @return OK
     */
    create(body: CreateProductEntityDataMappingDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitydatamapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update an product entity data mapping
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateProductEntityDataMappingDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitydatamapping/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an product entity data mapping
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitydatamapping/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Generate product entity data mappings by definition
     * @param definitionId The id of the product process definition
     */
    generateByDefinitionId(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitydatamapping/{definitionId}/generate";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateByDefinitionId(_response);
        });
    }

    protected processGenerateByDefinitionId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Clears the product entity data mappings by definition
     * @param definitionId The id of the product process definition
     */
    clearByDefinitionId(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitydatamapping/{definitionId}/clear";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearByDefinitionId(_response);
        });
    }

    protected processClearByDefinitionId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProductEntityLinkClient {
    /**
     * Get product entity links by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductEntityLinkDetailDto[]>;
    /**
     * Create a new entity link
     * @param dto The body of the created link
     */
    createEntityLink(dto: ProductEntityLinkCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductEntityLinkDetailDto[]>;
    /**
     * Update the entity Entity mapping
     * @param id The unique identifier of the entitylink
     * @param dto The body of the updated Entitylink
     */
    updateEntityLink(id: number, dto: ProductEntityLinkUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete the entity Entity mapping
     * @param entityLinkId The unique identifier of the entitylink
     */
    deleteEntityLink(entityLinkId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class ProductEntityLinkClient implements IProductEntityLinkClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get product entity links by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductEntityLinkDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitylink/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<ProductEntityLinkDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductEntityLinkDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntityLinkDetailDto[]>(null as any);
    }

    /**
     * Create a new entity link
     * @param dto The body of the created link
     */
    createEntityLink(dto: ProductEntityLinkCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductEntityLinkDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitylink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEntityLink(_response);
        });
    }

    protected processCreateEntityLink(response: AxiosResponse): Promise<ProductEntityLinkDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<ProductEntityLinkDetailDto[]>(result201);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductEntityLinkDetailDto[]>(null as any);
    }

    /**
     * Update the entity Entity mapping
     * @param id The unique identifier of the entitylink
     * @param dto The body of the updated Entitylink
     */
    updateEntityLink(id: number, dto: ProductEntityLinkUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitylink/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEntityLink(_response);
        });
    }

    protected processUpdateEntityLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the entity Entity mapping
     * @param entityLinkId The unique identifier of the entitylink
     */
    deleteEntityLink(entityLinkId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productentitylink/{entityLinkId}";
        if (entityLinkId === undefined || entityLinkId === null)
            throw new globalThis.Error("The parameter 'entityLinkId' must be defined.");
        url_ = url_.replace("{entityLinkId}", encodeURIComponent("" + entityLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEntityLink(_response);
        });
    }

    protected processDeleteEntityLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProductGroupClient {
    /**
     * Search for product groups
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param productProcessDefinitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, productProcessDefinitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfProductGroupSearchResultDto>;
    /**
     * Get product group detail
     * @param id The unique id
     */
    getDetail(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductGroupDetailDto>;
    /**
     * Update a product group
     * @param id The unique id
     * @param body the content of the product group, including its email addresses and members
     */
    update(id: number, body: ProductGroupUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a product group
     * @param id The unique id
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get the product process definitions that can be added to a product group
     */
    getSelectableDefinitions(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductGroupSelectableDefinitionDto[]>;
    /**
     * Create a product group
     * @param body the content of the product group, including its email addresses and members
     */
    create(body: ProductGroupCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
}

export class ProductGroupClient implements IProductGroupClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for product groups
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param productProcessDefinitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, productProcessDefinitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfProductGroupSearchResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productgroup/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (productProcessDefinitionId !== undefined && productProcessDefinitionId !== null)
            url_ += "productProcessDefinitionId=" + encodeURIComponent("" + productProcessDefinitionId) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfProductGroupSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfProductGroupSearchResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfProductGroupSearchResultDto>(null as any);
    }

    /**
     * Get product group detail
     * @param id The unique id
     */
    getDetail(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductGroupDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productgroup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<ProductGroupDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductGroupDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroupDetailDto>(null as any);
    }

    /**
     * Update a product group
     * @param id The unique id
     * @param body the content of the product group, including its email addresses and members
     */
    update(id: number, body: ProductGroupUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productgroup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a product group
     * @param id The unique id
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productgroup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the product process definitions that can be added to a product group
     */
    getSelectableDefinitions( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductGroupSelectableDefinitionDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productgroup/selectable-definitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectableDefinitions(_response);
        });
    }

    protected processGetSelectableDefinitions(response: AxiosResponse): Promise<ProductGroupSelectableDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductGroupSelectableDefinitionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroupSelectableDefinitionDto[]>(null as any);
    }

    /**
     * Create a product group
     * @param body the content of the product group, including its email addresses and members
     */
    create(body: ProductGroupCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }
}

export interface IProductProcessDefinitionClient {
    /**
     * Get all product process definitions
     */
    getAll(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinitionSearchResultDto[]>;
    /**
     * Search for product process definitions
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param organisation (optional) 
     * @param ovoNumber (optional) 
     * @param deliveryProcesDefinitionId (optional) 
     * @param statusType (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, organisation?: string | null | undefined, ovoNumber?: string | null | undefined, deliveryProcesDefinitionId?: number | null | undefined, statusType?: string | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfProductProcessDefinitionSearchResultDto>;
    /**
     * Get product process definition by id
     * @param id The unique id
     */
    getDetail(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinitionDetailDto>;
    /**
     * Update a product process definition
     * @param body the content of the definition
     * @return OK
     */
    update(id: number, body: ProductProcessDefinitionUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a product process definition
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Change status of a product process definition
     * @param id the unique id
     * @param statusType (optional) the status type
     * @return OK
     */
    changeStatus(id: number, statusType?: string | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Create a product process definition
     * @param body the content of the definition
     * @return OK
     */
    create(body: ProductProcessDefinitionCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Duplicate a product process definition
     * @param id the unique id
     * @param options the duplication options
     * @return OK
     */
    duplicate(id: number, options: ProductProcessDefinitionDuplicationOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Import a product process definition
     * @param parentDefinitionId (optional) 
     * @param file (optional) 
     * @return OK
     */
    import(parentDefinitionId?: number | null | undefined, file?: FileParameter | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Export a product process definition
     * @param id the unique id
     * @return OK
     */
    export(id: number, exportOptions: ProductProcessDefinitionExportOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Cascade delete a product process definition
     * @param id the unique id
     */
    cascadeDelete(id: number, cascadeDeleteOptions: ProductProcessDefinitionCascadeDeleteOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get dependencies report of a product process definition
     * @param id the unique id
     */
    getDependenciesReport(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinitionDependenciesReportDto>;
    /**
     * Validate cascade delete of a product process definition
     * @param id the unique id
     */
    cascadeDeleteValidate(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<boolean>;
    /**
     * Import a specification into the product process definition
     * @param id the product process definition id
     * @param importSpecificationDto the specification to import
     * @return OK
     */
    importSpecification(id: number, importSpecificationDto: ImportSpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ImportSpecificationResultDto>;
    /**
     * Generate a product process definition report.
     * @param id the unique id
     * @return OK
     */
    generateReport(id: number, reportingOptions: ProductProcessDefinitionReportingOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Get a product process definition report.
     * @param id the unique id
     * @return OK
     */
    getReport(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
}

export class ProductProcessDefinitionClient implements IProductProcessDefinitionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get all product process definitions
     */
    getAll( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinitionSearchResultDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProductProcessDefinitionSearchResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductProcessDefinitionSearchResultDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessDefinitionSearchResultDto[]>(null as any);
    }

    /**
     * Search for product process definitions
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param organisation (optional) 
     * @param ovoNumber (optional) 
     * @param deliveryProcesDefinitionId (optional) 
     * @param statusType (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, organisation?: string | null | undefined, ovoNumber?: string | null | undefined, deliveryProcesDefinitionId?: number | null | undefined, statusType?: string | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfProductProcessDefinitionSearchResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (organisation !== undefined && organisation !== null)
            url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
        if (ovoNumber !== undefined && ovoNumber !== null)
            url_ += "ovoNumber=" + encodeURIComponent("" + ovoNumber) + "&";
        if (deliveryProcesDefinitionId !== undefined && deliveryProcesDefinitionId !== null)
            url_ += "deliveryProcesDefinitionId=" + encodeURIComponent("" + deliveryProcesDefinitionId) + "&";
        if (statusType !== undefined && statusType !== null)
            url_ += "statusType=" + encodeURIComponent("" + statusType) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfProductProcessDefinitionSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfProductProcessDefinitionSearchResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfProductProcessDefinitionSearchResultDto>(null as any);
    }

    /**
     * Get product process definition by id
     * @param id The unique id
     */
    getDetail(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinitionDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<ProductProcessDefinitionDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductProcessDefinitionDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessDefinitionDetailDto>(null as any);
    }

    /**
     * Update a product process definition
     * @param body the content of the definition
     * @return OK
     */
    update(id: number, body: ProductProcessDefinitionUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a product process definition
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Change status of a product process definition
     * @param id the unique id
     * @param statusType (optional) the status type
     * @return OK
     */
    changeStatus(id: number, statusType?: string | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/status?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (statusType === null)
            throw new globalThis.Error("The parameter 'statusType' cannot be null.");
        else if (statusType !== undefined)
            url_ += "statusType=" + encodeURIComponent("" + statusType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeStatus(_response);
        });
    }

    protected processChangeStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a product process definition
     * @param body the content of the definition
     * @return OK
     */
    create(body: ProductProcessDefinitionCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Duplicate a product process definition
     * @param id the unique id
     * @param options the duplication options
     * @return OK
     */
    duplicate(id: number, options: ProductProcessDefinitionDuplicationOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/duplicate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Import a product process definition
     * @param parentDefinitionId (optional) 
     * @param file (optional) 
     * @return OK
     */
    import(parentDefinitionId?: number | null | undefined, file?: FileParameter | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/import?";
        if (parentDefinitionId !== undefined && parentDefinitionId !== null)
            url_ += "parentDefinitionId=" + encodeURIComponent("" + parentDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Export a product process definition
     * @param id the unique id
     * @return OK
     */
    export(id: number, exportOptions: ProductProcessDefinitionExportOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/export";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Cascade delete a product process definition
     * @param id the unique id
     */
    cascadeDelete(id: number, cascadeDeleteOptions: ProductProcessDefinitionCascadeDeleteOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/cascade-delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cascadeDeleteOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCascadeDelete(_response);
        });
    }

    protected processCascadeDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get dependencies report of a product process definition
     * @param id the unique id
     */
    getDependenciesReport(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductProcessDefinitionDependenciesReportDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/dependencies/report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDependenciesReport(_response);
        });
    }

    protected processGetDependenciesReport(response: AxiosResponse): Promise<ProductProcessDefinitionDependenciesReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductProcessDefinitionDependenciesReportDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductProcessDefinitionDependenciesReportDto>(null as any);
    }

    /**
     * Validate cascade delete of a product process definition
     * @param id the unique id
     */
    cascadeDeleteValidate(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/cascade-delete/validate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCascadeDeleteValidate(_response);
        });
    }

    protected processCascadeDeleteValidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Import a specification into the product process definition
     * @param id the product process definition id
     * @param importSpecificationDto the specification to import
     * @return OK
     */
    importSpecification(id: number, importSpecificationDto: ImportSpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ImportSpecificationResultDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/import-specification";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importSpecificationDto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportSpecification(_response);
        });
    }

    protected processImportSpecification(response: AxiosResponse): Promise<ImportSpecificationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<ImportSpecificationResultDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportSpecificationResultDto>(null as any);
    }

    /**
     * Generate a product process definition report.
     * @param id the unique id
     * @return OK
     */
    generateReport(id: number, reportingOptions: ProductProcessDefinitionReportingOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/generate-report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportingOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateReport(_response);
        });
    }

    protected processGenerateReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get a product process definition report.
     * @param id the unique id
     * @return OK
     */
    getReport(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productprocessdefinition/{id}/report";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IProductSpecificationClient {
    /**
     * Search for product specifications
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param definitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfSearchProductSpecificationDto>;
    /**
     * Get product specifications by id
     * @param id The unique definitionId
     */
    getById(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductSpecificationDetailDto>;
    /**
     * Update a product specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateProductSpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a product specifiation
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Get product specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductSpecificationDetailDto[]>;
    /**
     * Create a product specification
     * @param body the content to create
     * @return OK
     */
    create(body: CreateProductSpecificationDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Generate a feature catalog for the product specification
     * @param id the unique id
     * @param featureCatalogOptions The feature catalog options
     * @return OK
     */
    generateFeatureCatalog(id: number, featureCatalogOptions: FeatureCatalogOptionsDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Generate a feature catalog for the product specification
     * @param id the unique id
     * @return OK
     */
    getFeatureCatalog(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    /**
     * Has unique schema for a product specification
     * @param schema (optional) The schema search string
     * @param dataConnectionCode (optional) The data connection code
     * @return OK
     */
    hasUniqueSchema(schema?: string | undefined, dataConnectionCode?: string | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<boolean | null>;
}

export class ProductSpecificationClient implements IProductSpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Search for product specifications
     * @param id (optional) 
     * @param label (optional) 
     * @param description (optional) 
     * @param definitionId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    search(id?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitionId?: number | null | undefined, order?: string | null | undefined, orderDirection?: OrderDirection | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<DatatableDtoOfSearchProductSpecificationDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/search?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (definitionId !== undefined && definitionId !== null)
            url_ += "definitionId=" + encodeURIComponent("" + definitionId) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new globalThis.Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DatatableDtoOfSearchProductSpecificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<DatatableDtoOfSearchProductSpecificationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatatableDtoOfSearchProductSpecificationDto>(null as any);
    }

    /**
     * Get product specifications by id
     * @param id The unique definitionId
     */
    getById(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductSpecificationDetailDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ProductSpecificationDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductSpecificationDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSpecificationDetailDto>(null as any);
    }

    /**
     * Update a product specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: UpdateProductSpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a product specifiation
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get product specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductSpecificationDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<ProductSpecificationDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductSpecificationDetailDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSpecificationDetailDto[]>(null as any);
    }

    /**
     * Create a product specification
     * @param body the content to create
     * @return OK
     */
    create(body: CreateProductSpecificationDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Generate a feature catalog for the product specification
     * @param id the unique id
     * @param featureCatalogOptions The feature catalog options
     * @return OK
     */
    generateFeatureCatalog(id: number, featureCatalogOptions: FeatureCatalogOptionsDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/{id}/feature-catalog/generate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(featureCatalogOptions);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateFeatureCatalog(_response);
        });
    }

    protected processGenerateFeatureCatalog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Generate a feature catalog for the product specification
     * @param id the unique id
     * @return OK
     */
    getFeatureCatalog(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/{id}/feature-catalog";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeatureCatalog(_response);
        });
    }

    protected processGetFeatureCatalog(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Has unique schema for a product specification
     * @param schema (optional) The schema search string
     * @param dataConnectionCode (optional) The data connection code
     * @return OK
     */
    hasUniqueSchema(schema?: string | undefined, dataConnectionCode?: string | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<boolean | null> {
        let url_ = this.baseUrl + "/backoffice/api/v1/productspecification/has-unique-schema?";
        if (schema === null)
            throw new globalThis.Error("The parameter 'schema' cannot be null.");
        else if (schema !== undefined)
            url_ += "schema=" + encodeURIComponent("" + schema) + "&";
        if (dataConnectionCode !== undefined && dataConnectionCode !== null)
            url_ += "dataConnectionCode=" + encodeURIComponent("" + dataConnectionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasUniqueSchema(_response);
        });
    }

    protected processHasUniqueSchema(response: AxiosResponse): Promise<boolean | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<boolean | null>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean | null>(null as any);
    }
}

export interface IProductTransformationClient {
    /**
     * Get product transformations by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductTransformationDetailDto[]>;
    /**
     * Create a product transformation
     * @param body the content to create
     * @return OK
     */
    create(body: ProductTransformationCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update a product transformation
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: ProductTransformationUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a product transformation
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class ProductTransformationClient implements IProductTransformationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get product transformations by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductTransformationDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformation/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<ProductTransformationDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductTransformationDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductTransformationDetailDto[]>(null as any);
    }

    /**
     * Create a product transformation
     * @param body the content to create
     * @return OK
     */
    create(body: ProductTransformationCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update a product transformation
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: ProductTransformationUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a product transformation
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProductTransformationLookupLinkClient {
    /**
     * Get lookup links by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductTransformationLookupLinkDetailDto[]>;
    /**
     * Get lookup links by source entity
     * @param sourceEntityId The unique sourceEntityId
     */
    getBySourceEntity(sourceEntityId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductTransformationLookupLinkDetailDto[]>;
    /**
     * Create a new product transformation lookup link
     * @param dto The body of the created link
     */
    create(dto: ProductTransformationLookupLinkCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update the entity product transformation lookup link
     * @param id The unique identifier of the link
     * @param dto The body of the updated link
     */
    update(id: number, dto: ProductTransformationLookupLinkUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete the entity product transformation lookup link
     * @param id The unique identifier of the link
     */
    remove(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class ProductTransformationLookupLinkClient implements IProductTransformationLookupLinkClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get lookup links by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductTransformationLookupLinkDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformationlookuplink/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<ProductTransformationLookupLinkDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductTransformationLookupLinkDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductTransformationLookupLinkDetailDto[]>(null as any);
    }

    /**
     * Get lookup links by source entity
     * @param sourceEntityId The unique sourceEntityId
     */
    getBySourceEntity(sourceEntityId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductTransformationLookupLinkDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformationlookuplink/getbysourceentity/{sourceEntityId}";
        if (sourceEntityId === undefined || sourceEntityId === null)
            throw new globalThis.Error("The parameter 'sourceEntityId' must be defined.");
        url_ = url_.replace("{sourceEntityId}", encodeURIComponent("" + sourceEntityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySourceEntity(_response);
        });
    }

    protected processGetBySourceEntity(response: AxiosResponse): Promise<ProductTransformationLookupLinkDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductTransformationLookupLinkDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductTransformationLookupLinkDetailDto[]>(null as any);
    }

    /**
     * Create a new product transformation lookup link
     * @param dto The body of the created link
     */
    create(dto: ProductTransformationLookupLinkCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformationlookuplink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update the entity product transformation lookup link
     * @param id The unique identifier of the link
     * @param dto The body of the updated link
     */
    update(id: number, dto: ProductTransformationLookupLinkUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformationlookuplink/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the entity product transformation lookup link
     * @param id The unique identifier of the link
     */
    remove(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/producttransformationlookuplink/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISourceEntityClient {
    /**
     * Get source entities by defintion
     * @param definitionId The unique definitionId
     */
    getByDelivery(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SourceEntityDetailDto[]>;
    /**
     * Get source entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SourceEntityDetailDto[]>;
    /**
     * Create a source entity
     * @param body the content to create
     * @return OK
     */
    create(body: SourceEntityCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update a source entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: SourceEntityUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a source entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class SourceEntityClient implements ISourceEntityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get source entities by defintion
     * @param definitionId The unique definitionId
     */
    getByDelivery(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SourceEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourceentity/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDelivery(_response);
        });
    }

    protected processGetByDelivery(response: AxiosResponse): Promise<SourceEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SourceEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceEntityDetailDto[]>(null as any);
    }

    /**
     * Get source entities by specification
     * @param specificationId The unique specificationId
     */
    getBySpecification(specificationId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SourceEntityDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourceentity/getbyspecification/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new globalThis.Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySpecification(_response);
        });
    }

    protected processGetBySpecification(response: AxiosResponse): Promise<SourceEntityDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SourceEntityDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceEntityDetailDto[]>(null as any);
    }

    /**
     * Create a source entity
     * @param body the content to create
     * @return OK
     */
    create(body: SourceEntityCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourceentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update a source entity
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: SourceEntityUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourceentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a source entity
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourceentity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISourceSpecificationClient {
    /**
     * Get source specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SourceSpecificationDetailDto[]>;
    /**
     * Create a source specification
     * @param body the content to create
     * @return OK
     */
    create(body: SourceSpecificationCreateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<CreatedDto>;
    /**
     * Update a source specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: SourceSpecificationUpdateDto, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
    /**
     * Delete a source Specifiation
     * @param id the unique id
     * @return OK
     */
    delete(id: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<void>;
}

export class SourceSpecificationClient implements ISourceSpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get source specifications by definition
     * @param definitionId The unique definitionId
     */
    getByDefinition(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SourceSpecificationDetailDto[]> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourcespecification/getbydefinition/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDefinition(_response);
        });
    }

    protected processGetByDefinition(response: AxiosResponse): Promise<SourceSpecificationDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SourceSpecificationDetailDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceSpecificationDetailDto[]>(null as any);
    }

    /**
     * Create a source specification
     * @param body the content to create
     * @return OK
     */
    create(body: SourceSpecificationCreateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<CreatedDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourcespecification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<CreatedDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedDto>(null as any);
    }

    /**
     * Update a source specification
     * @param id the unique id
     * @param body the content to update
     * @return OK
     */
    update(id: number, body: SourceSpecificationUpdateDto , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourcespecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a source Specifiation
     * @param id the unique id
     * @return OK
     */
    delete(id: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/api/v1/sourcespecification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISystemTableClient {
    /**
     * Get system tables
     */
    get(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SystemTablesDto>;
}

export class SystemTableClient implements ISystemTableClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    /**
     * Get system tables
     */
    get( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SystemTablesDto> {
        let url_ = this.baseUrl + "/backoffice/api/v1/systemtable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SystemTablesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SystemTablesDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemTablesDto>(null as any);
    }
}

export interface DatabaseOverviewDto {
    overview?: OverviewDto[];
}

export interface OverviewDto {
    key?: string;
    geenTabel?: string[];
    geenConfiguratie?: string[];
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface CodeListAttributeMappingDto {
    attributeMappings?: { [key in keyof typeof CodeListAttributeType]?: EntityAttributeDetailDto; };
}

export enum CodeListAttributeType {
    Code = 0,
    Name = 1,
    Description = 2,
}

export interface EntityAttributeDetailDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    order?: number | null;
    dataType?: EnumerationDto;
    length?: number | null;
    decimalCount?: number | null;
    isIdentifying?: boolean | null;
    isMandatory?: boolean | null;
    isCalculated?: boolean | null;
    isDomain?: boolean | null;
    allowedValues?: string | null;
}

export interface EnumerationDto {
    id?: number;
    name?: string;
}

export interface SaveCodeListAttributeMappingDto {
    attributeMappings?: { [key in keyof typeof CodeListAttributeType]?: number; } | null;
}

export interface DataConnectionDto {
    id?: number;
    code?: string;
    label?: string;
    isReadOnly?: boolean | null;
    busyCount?: number | null;
    switch?: boolean | null;
    isSwitching?: boolean | null;
}

export interface DeliveryEntityDetailDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    format?: FormatTypeDto | null;
    model?: EntityModelLinkDto | null;
    crs?: CrsDto | null;
    dataConnection?: DataConnectionDto | null;
    schema?: string | null;
}

export interface FormatTypeDto {
    id?: number;
    code?: string;
    name?: string;
}

export interface EntityModelLinkDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    contextTypeId?: number | null;
    contextTypeName?: string | null;
    entityTypeId?: number | null;
    entityTypeName?: string | null;
    hasHistory?: boolean | null;
    attributes?: EntityAttributeDetailDto[];
    codeListAttributeMappings?: { [key in keyof typeof CodeListAttributeTypeEnum]?: EntityAttributeDetailDto; };
}

export enum CodeListAttributeTypeEnum {
    Code = 0,
    Name = 1,
    Description = 2,
}

export interface CrsDto {
    id?: number;
    name?: string;
}

export interface CreatedDto {
    id?: number;
}

export interface CreateDeliveryEntityDto {
    deliverySpecificationId: number;
    code: string;
    label: string;
    description: string;
    format: string;
    crs: string;
    modelId: number;
    dataConnectionId?: number | null;
    schema?: string | null;
}

export interface UpdateDeliveryEntityDto {
    code: string;
    label: string;
    description: string;
    format: string;
    crs: string;
    modelId: number;
    dataConnectionId?: number | null;
    schema?: string | null;
}

export interface DeliveryEntityLinkDetailDto {
    id?: number;
    fromEntity?: DeliveryEntityDetailDto | null;
    toEntity?: DeliveryEntityDetailDto | null;
    attributeMappings?: (DeliveryEntityLinkAttributeMappingDto | null)[] | null;
}

export interface DeliveryEntityLinkAttributeMappingDto {
    linkId?: number;
    fromAttribute?: EntityAttributeDetailDto | null;
    toAttribute?: EntityAttributeDetailDto | null;
}

export interface DeliveryEntityLinkCreateDto {
    specificationId?: number;
    fromEntityId?: number;
    toEntityId?: number;
    fromAttributeId?: number;
    toAttributeId?: number;
}

export interface DeliveryEntityLinkUpdateDto {
    fromEntityId?: number;
    toEntityId?: number;
    deliveryEntityAttributeLinkId?: number;
    fromAttributeId?: number;
    toAttributeId?: number;
}

export interface DeliveryProcessDefinitionSearchResultDto {
    id?: number;
    label?: string | null;
    organisation?: string | null;
    ovoNumber?: string | null;
    statusId?: number;
}

export interface DatatableDtoOfDeliveryProcessDefinitionSearchResultDto {
    items?: DeliveryProcessDefinitionSearchResultDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export enum OrderDirection {
    Ascending = 0,
    Descending = 1,
}

export interface DeliveryProcessDefinitionDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    organisation?: string | null;
    ovoNumber?: string | null;
    statusId?: number;
    parent?: DeliveryProcessDefinitionBasicDto | null;
}

export interface DeliveryProcessDefinitionBasicDto {
    id?: number;
    label?: string | null;
}

export interface UpdateDeliveryProcessDefinitionDto {
    label: string;
    description: string;
    ovoNumber: string;
}

export interface CreateDeliveryProcessDefinitionDto {
    label: string;
    description: string;
    ovoNumber: string;
}

export interface DeliveryProcessDefinitionDuplicationOptionsDto {
    duplicateEntityModels?: boolean;
    duplicateProductProcessDefinitions?: boolean;
    duplicateDeliveryQualityChecks?: boolean;
}

export interface DeliveryProcessDefinitionExportOptionsDto {
    includeProductProcessDefinitions?: boolean;
}

export interface DeliveryProcessDefinitionCascadeDeleteOptionsDto {
    deleteEntityModels?: boolean;
}

export interface DeliveryProcessDefinitionDependenciesReportDto {
    deliveryProcessDefinitions?: DeliveryProcessDefinitionBasicDto[];
    productProcessDefinitions?: ProductProcessDefinitionBasicDto[];
    processTriggers?: ProcessTriggerBasicDto[];
    deliveryRuns?: DeliveryRunBasicDto[];
}

export interface ProductProcessDefinitionBasicDto {
    id?: number;
    label?: string | null;
}

export interface ProcessTriggerBasicDto {
    id?: number;
    triggerType?: EnumerationDto | null;
    description?: string | null;
}

export interface DeliveryRunBasicDto {
    id?: number;
    status?: DeliveryRunBasicStatusDto;
    isFailed?: boolean;
    isDryRun?: boolean;
}

export interface DeliveryRunBasicStatusDto {
    description?: string;
    executionDate?: Date | null;
}

export interface DeliveryProcessDefinitionReportingOptionsDto {
}

export interface ImportSpecificationResultDto {
    id?: number;
    targetSpecification?: ImportSpecificationType;
}

export enum ImportSpecificationType {
    DeliverySpecification = 1,
    OperationSpecification = 2,
    SourceSpecification = 3,
    ProductSpecification = 4,
}

export interface ImportSpecificationDto {
    productProcessDefinition?: ImportSpecificationProcessDefinitionDto | null;
    deliveryProcessDefinition?: ImportSpecificationProcessDefinitionDto | null;
    target?: ImportSpecificationType | null;
}

export interface ImportSpecificationProcessDefinitionDto {
    definitionId?: number;
    specificationType?: ImportSpecificationType;
}

export interface DeliveryQualityCheckDetailDto {
    id?: number;
    code?: string;
    qualityCheckType?: EnumerationDto | null;
    isEnabled?: boolean;
    testFunction?: string | null;
    parameters?: { [key: string]: string; } | null;
    deliveryEntityId?: number | null;
}

export interface SaveBasicQualityCheckDto {
    code?: string;
    testFunction?: string;
    isEnabled?: boolean;
}

export interface SaveStandardQualityCheckStatusDto {
    code?: string;
    isEnabled?: boolean;
}

export interface SaveStandardQualityCheckDto {
    deliveryEntityId?: number;
    code?: string;
    testFunction?: string;
    parameters?: { [key: string]: string; } | null;
}

export interface DeleteQualityCheckDto {
    code?: string;
    qualityCheckType?: EnumerationDto;
}

export interface DatatableDtoOfSearchDeliverySpecificationDto {
    items?: SearchDeliverySpecificationDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface SearchDeliverySpecificationDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    definitionId?: number | null;
}

export interface DeliverySpecificationDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    tolerance?: number;
    hasExactPrecision?: boolean;
    skipCheck?: boolean;
    skipImport?: boolean;
    skipUpload?: boolean;
}

export interface CreateDeliverySpecificationDto {
    deliveryProcessDefinitionId: number;
    label: string;
    description: string;
    schema?: string | null;
    tolerance?: number;
    hasExactPrecision?: boolean;
    skipImport?: boolean;
    skipUpload?: boolean;
}

export interface UpdateDeliverySpecificationDto {
    label: string;
    description: string;
    tolerance?: number;
    hasExactPrecision?: boolean;
    skipImport?: boolean;
    skipUpload?: boolean;
}

export interface PartialUpdateDeliverySpecificationDto {
    skipCheck?: boolean | null;
}

export interface DeliveryTransformationDetailDto {
    id?: number;
    transformationType?: TransformationTypeDto | null;
    fromEntity?: DeliveryEntityDetailDto | null;
    toEntity?: OperationEntityDetailDto | null;
    attributeMappings?: (DeliveryTransformationAttributeMappingDto | null)[] | null;
    parameter?: string | null;
}

export interface TransformationTypeDto {
    id?: number;
    name?: string;
}

export interface OperationEntityDetailDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    model?: EntityModelLinkDto | null;
    crs?: CrsDto | null;
}

export interface DeliveryTransformationAttributeMappingDto {
    id?: number;
    fromAttribute?: EntityAttributeDetailDto | null;
    toAttribute?: EntityAttributeDetailDto | null;
}

export interface CreateDeliveryTransformationDto {
    deliveryProcessDefinitionId?: number;
    transformationType?: string | null;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: CreateDeliveryTransformationAttributeMappingDto[] | null;
    parameter?: string | null;
}

export interface CreateDeliveryTransformationAttributeMappingDto {
    id?: number | null;
    fromAttributeId?: number;
    toAttributeId?: number;
}

export interface UpdateDeliveryTransformationDto {
    deliveryProcessDefinitionId?: number;
    transformationType?: string | null;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: CreateDeliveryTransformationAttributeMappingDto[] | null;
    parameter?: string | null;
}

export interface CreateEntityAttributeDto {
    entityModelId: number;
    code: string;
    label: string;
    description: string;
    order: number;
    dataType: string;
    length: number;
    decimalCount?: number | null;
    isIdentifying: boolean;
    isMandatory: boolean;
    isCalculated: boolean;
    isDomain: boolean;
    allowedValues?: string | null;
}

export interface UpdateEntityAttributeDto {
    code: string;
    label: string;
    description: string;
    order: number;
    dataType: string;
    length: number;
    decimalCount?: number | null;
    isIdentifying: boolean;
    isMandatory: boolean;
    isCalculated: boolean;
    isDomain: boolean;
    allowedValues?: string | null;
}

export interface DatatableDtoOfSearchEntityModelDto {
    items?: SearchEntityModelDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface SearchEntityModelDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    contextTypeName?: string | null;
    entityTypeName?: string | null;
    hasHistory?: boolean | null;
    statusId?: number;
}

export interface EntityModelDetailDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    contextType?: EnumerationDto;
    entityType?: EnumerationDto;
    hasHistory?: boolean | null;
    statusId?: number;
}

export interface UpdateEntityModelDto {
    code: string;
    label: string;
    description: string;
    contextType: string;
    entityType: string;
    hasHistory: boolean;
}

export interface CreateEntityModelDto {
    code: string;
    label: string;
    description: string;
    contextType: string;
    entityType: string;
    hasHistory: boolean;
}

export interface EntityModelDependenciesReportDto {
    deliveryProcessDefinitions?: DeliveryProcessDefinitionBasicDto[];
    productProcessDefinitions?: ProductProcessDefinitionBasicDto[];
}

export interface GeckoSpecificationSearchResultDto {
    specificationId?: number;
    versionMajor?: number;
    versionMinor?: number;
    specificationCode?: string;
    specificationStatus?: GeckoSpecificationStatusType;
}

export enum GeckoSpecificationStatusType {
    None = 0,
    Draft = 1,
    ValidatedDraft = 2,
    Active = 3,
    Archived = 4,
    Removed = 5,
}

export interface GeckoTestDto {
    controlType?: GeckoControlType;
    deliveryEntityId?: number | null;
    test?: TestDto;
    operations?: OperationDto[];
}

export enum GeckoControlType {
    InitialChecks = 1,
    CriticalChecks = 2,
    AutomaticChecks = 3,
    SemiAutomaticChecks = 4,
}

export interface TestDto {
    id?: string | null;
    code?: string | null;
    name?: string | null;
    description?: string | null;
    parameters?: BaseTestParameters | null;
    function?: string | null;
    availability?: string | null;
    comment?: string | null;
    cause?: string | null;
    noiseTestId?: string | null;
}

export interface BaseTestParameters {
    discriminator: string;
}

export interface AttributePrecisionTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    minimumPrecision: number;
    minPercentageConform: number;
    featureAttribute: string;
}

export interface AttributeUniqueTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    featureTypeAttribute: string;
}

export interface CheckDateValidityTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    featureTypeAttributeFilter?: string | null;
    dateFormat?: string | null;
}

export interface CheckReadabilityTestParametersDto extends BaseTestParameters {
}

export interface CheckXmlReadabilityTestParametersDto extends BaseTestParameters {
}

export interface CheckZipTestParametersDto extends BaseTestParameters {
}

export interface CoordinatePrecisionTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    minimumPrecision: number;
    minPercentageConform?: number | null;
}

export interface CoordinatesInFlandersTestParametersDto extends BaseTestParameters {
}

export interface DistancePointTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    minDistance: number;
}

export interface DomainTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
}

export interface DonutPolygonTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    featureTypeIdentifyingAttribute?: string | null;
}

export interface DxfAutoCadComplianceTestParametersDto extends BaseTestParameters {
}

export interface DxfUnsupportedGeometryTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface DxfVersionTestParametersDto extends BaseTestParameters {
}

export interface EmptyFeatureTypeTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
}

export interface ExcessFeatureAttributesTestParametersDto extends BaseTestParameters {
}

export interface ExcessFeatureTypesTestParametersDto extends BaseTestParameters {
}

export interface FeatureAttributeDefinitionTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface FeatureTypeChangesTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    exceptionFeatureAttributes?: string | null;
    additionsAllowed: boolean;
}

export interface FeatureTypeNotUniqueTestParametersDto extends BaseTestParameters {
}

export interface FeatureTypeThresholdTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    threshold: number;
}

export interface GeometryTypeTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface GraDatumTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
}

export interface GraVerduidelijkingTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
}

export interface IdentifyingAttributeUniqueTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface IntegrationControlTestParametersDto extends BaseTestParameters {
    inputFeatureType: string;
    inputFeatureTypeIdentifyingAttribute?: string | null;
    integrationFeatureType: string;
    integrationFeatureTypeIdentifyingAttribute?: string | null;
    tolerance?: number | null;
    attributeChecks?: string[] | null;
    contour: string;
    ignoreZone?: string | null;
}

export interface LineMinimumLengthTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    minimumLength: number;
}

export interface LineNoCrossingTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
}

export interface LineSegmentLengthTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    tolerance?: number | null;
}

export interface LogicRelShouldExistTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    featureAttribute1: string;
    featureAttribute2: string;
}

export interface ManualMissingFeatureTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    additionalAttribute?: string | null;
}

export interface ManualTestParametersDto extends BaseTestParameters {
    featureType?: string | null;
    featureTypeIdentifyingAttribute?: string | null;
    additionalAttribute?: string | null;
}

export interface MissingFeatureAttributesTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface MissingFeatureTypesTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface MultiPartTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
}

export interface NoDoubleVerticesTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    tolerance?: number | null;
}

export interface NoIdenticalSegmentsTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    tolerance?: number | null;
}

export interface NullGeometryTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface PolygonDigitizeOrderTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
}

export interface PolygonMinimumAreaTestParametersDto extends BaseTestParameters {
    featureType: string;
    featureTypeIdentifyingAttribute?: string | null;
    minimumArea: number;
}

export interface PolygonSliverTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    featureTypeIdentifyingAttribute?: string | null;
    perimeterAreaRatio: number;
    minimumArea: number;
}

export interface RelativeDateCheckTestParameterDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeDateAttribute: string;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeDateAttribute: string;
    relativeMark: string;
    pairingAttribute?: string | null;
    firstPairingAttribute?: string | null;
    secondPairingAttribute?: string | null;
}

export interface ShpAttributeDefinitionTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    datatypeOnly: boolean;
    exceptionFeatureAttributes?: string | null;
}

export interface SnappingToleranceTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    buffer: number;
    tolerance?: number | null;
    checkOnVertexLevel: boolean;
}

export interface SpatialTestAllDifferingPairsTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    intersectionMatrix: string;
    pairingAttribute: string;
}

export interface SpatialTestAllDissolveTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    intersectionMatrix: string;
    dissolveAttribute?: string | null;
}

export interface SpatialTestAllSimilarPairsTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    intersectionMatrix: string;
    pairingAttribute: string;
}

export interface SpatialTestAllTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    intersectionMatrix: string;
}

export interface SpatialTestTillMatchSimilarPairsTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    intersectionMatrix: string;
    count?: string | null;
    pairingAttribute: string;
}

export interface SpatialTestTillMatchTestParametersDto extends BaseTestParameters {
    firstFeatureType: string;
    firstFeatureTypeIdentifyingAttribute?: string | null;
    firstFeatureTypeAttributeFilter?: string | null;
    firstFeatureTypeTopologyFilter?: string | null;
    firstTopologyFeatureType?: string | null;
    secondFeatureType: string;
    secondFeatureTypeIdentifyingAttribute?: string | null;
    secondFeatureTypeAttributeFilter?: string | null;
    secondFeatureTypeTopologyFilter?: string | null;
    secondTopologyFeatureType?: string | null;
    tolerance?: number | null;
    intersectionMatrix: string;
    count?: string | null;
}

export interface TopoAanwezigheidTestParametersDto extends BaseTestParameters {
    inputEntiteit: string;
    inputEntiteitIdentifyingAttribute?: string | null;
    controleEntiteit: string;
    controleEntiteitIdentifyingAttribute?: string | null;
    searchRadius: number;
}

export interface TopoAfwijkingTestParametersDto extends BaseTestParameters {
    controleEntiteit: string;
    controleEntiteitIdentifyingAttribute?: string | null;
    controleEntiteitHeightAttribute?: string | null;
    inputEntiteit: string;
    inputEntiteitIdentifyingAttribute?: string | null;
    inputEntiteitHeightAttribute?: string | null;
    searchRadius: number;
    maxVerticalDifference?: number | null;
    maxHorizontalDifference: number;
}

export interface ValidGeometryTestParametersDto extends BaseTestParameters {
    featureTypes: string[];
    excludeErrorCodes?: string[] | null;
}

export interface ValidShapefileTestParametersDto extends BaseTestParameters {
}

export interface OperationDto {
    code?: string | null;
    name?: string | null;
    function?: string | null;
    availability?: string | null;
    comment?: string | null;
    mutableOutput?: boolean;
    persist?: boolean;
    parameters?: BaseOperationParameters | null;
}

export interface BaseOperationParameters {
    outputFeatureTypes?: OutputFeatureTypeDto[] | null;
    discriminator: string;
}

export interface OutputFeatureTypeDto {
    identifyingAttribute?: string | null;
    name?: string | null;
}

export interface BufferOperationParametersDto extends BaseOperationParameters {
    bufferDistance?: number;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface InputFeatureTypeDto {
    identifyingAttribute?: string | null;
    name?: string | null;
    attributeFilter?: string | null;
    topologyFilter?: string | null;
    topologyFilterFeatureTypeName?: string | null;
}

export interface CommonBoundariesOperationParametersDto extends BaseOperationParameters {
    tolerance?: number | null;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface CreateEmptyFeatureTypeOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: FeatureType[] | null;
}

export interface FeatureType {
    code?: string | null;
    name?: string | null;
    description?: string | null;
    geometryTypes?: GeometryType[] | null;
    attributes?: FeatureTypeAttribute[] | null;
    format?: FormatType | null;
    delimiter?: string | null;
    coordinateColumnNames?: FeatureTypeCoordinateColumnNames | null;
    sourceType?: SourceType | null;
}

export interface Enumeration {
    name?: string | null;
    id?: number;
    discriminator: string;
}

export interface ForgivingEnumeration extends Enumeration {
}

export interface GeometryType extends ForgivingEnumeration {
    hasMeasureValue?: boolean;
    hasElevationValue?: boolean;
}

export interface ValidationStatus extends Enumeration {
}

export interface SpecificationStatus extends Enumeration {
}

export interface Pipeline extends ForgivingEnumeration {
}

export interface DataType extends ForgivingEnumeration {
    hasPrecision?: boolean;
    hasLength?: boolean;
    hasScale?: boolean;
}

export interface DomainType extends ForgivingEnumeration {
}

export interface FormatType extends ForgivingEnumeration {
}

export interface SourceType extends ForgivingEnumeration {
}

export interface Availability extends ForgivingEnumeration {
}

export interface ControlType extends ForgivingEnumeration {
}

export interface CoordinateSystem extends ForgivingEnumeration {
}

export interface DatasetType extends ForgivingEnumeration {
}

export interface DisplayGroup extends ForgivingEnumeration {
    order?: number;
    downloadPriority?: number | null;
}

export interface FactoryMessageLevel extends ForgivingEnumeration {
}

export interface NotificationCause extends ForgivingEnumeration {
    display?: string | null;
}

export interface OgcApiFeaturesCollectionId extends ForgivingEnumeration {
}

export interface OperationFunction extends ForgivingEnumeration {
}

export interface QualitySystemType extends ForgivingEnumeration {
}

export interface SerializationType extends ForgivingEnumeration {
}

export interface StatisticFunction extends ForgivingEnumeration {
}

export interface StyleSource extends ForgivingEnumeration {
}

export interface TestFunction extends ForgivingEnumeration {
    isManual?: boolean;
    run?: RunStyle;
}

export enum RunStyle {
    Always = 0,
    OnlyDelivery = 1,
    OnlyRedelivery = 2,
}

export interface FeatureTypeAttribute {
    code?: string | null;
    name?: string | null;
    description?: string | null;
    isIdentifying?: boolean;
    order?: number | null;
    dataType?: DataType | null;
    domain?: Domain | null;
    isRequired?: boolean;
    precision?: number;
    scale?: number;
    length?: number;
    hasDomain?: boolean;
}

export interface Domain {
    name?: string | null;
    type?: DomainType | null;
}

export interface FeatureTypeCoordinateColumnNames {
    xColumnName?: string | null;
    yColumnName?: string | null;
    zColumnName?: string | null;
}

export interface CreateVertexOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    filterDoubleVertices?: boolean | null;
}

export interface DifferenceOperationParametersDto extends BaseOperationParameters {
    tolerance?: number | null;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface DissolveOperationParametersDto extends BaseOperationParameters {
    dissolveAttribute?: string | null;
    createMultiPart?: boolean;
    tolerance?: number | null;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface FileCompareOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    zone?: InputFeatureTypeDto | null;
    onlyChanges?: boolean;
    featureAttributePairs?: AttributePair[] | null;
    tolerance?: number | null;
}

export interface AttributePair {
    featureAttribute1?: string | null;
    featureAttribute2?: string | null;
}

export interface IntersectLinesOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface IntersectPolygonsOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypesCount?: number | null;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface JoinOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    inputFeatureJoinAttribute?: string | null;
    joinFeatureJoinAttribute?: string | null;
    joinType?: string | null;
}

export interface JoinRestApiOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    restApiUrl?: string | null;
    restApiContentType?: string | null;
    restApiKey?: string | null;
    restApiJsonPathQuery?: string | null;
    inputFeatureJoinAttribute?: string | null;
    outputFeatureAttributeName?: string | null;
}

export interface LineSplitterOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypesCount?: number | null;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    minimumLength?: number | null;
}

export interface MergeOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface MultipartToSinglepartOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface PolygonSplitterOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypesCount?: number | null;
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    minimumArea?: number | null;
}

export interface PolygonToLineOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface ReadGrbAnoAsBuiltPlanOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    dxfLayersFilter?: string | null;
    dxfFileAttribute?: string | null;
}

export interface ReadOgcFeaturesOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    ogcApiUrl?: string | null;
    ogcApiLayer?: string | null;
    limitFeatures?: number | null;
}

export interface SelectOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface SpatialJoinOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
    joinType: string;
    tolerance?: number | null;
    intersectionMatrix: string;
}

export interface TrimOperationParametersDto extends BaseOperationParameters {
    inputFeatureTypes?: InputFeatureTypeDto[] | null;
}

export interface GeckoStandardTestTypeDto {
    id?: number;
    name?: string;
    testFunction?: GeckoTestFunction;
    entityTypes?: string[];
    isDisabled?: boolean | null;
    parameters?: GeckoStandardTestParameterTypeDto[];
}

export enum GeckoTestFunction {
    CheckZIP = 0,
    CheckReadability = 1,
    ExcessFeatureAttribute = 2,
    ExcessFeatureType = 3,
    FeatureTypeNotUnique = 4,
    MissingFeatureTypes = 5,
    GeometryType = 6,
    EmptyFeatureType = 7,
    MissingFeatureAttributes = 8,
    FeatureAttributeDefinition = 9,
    IdentifyingAttributeUnique = 10,
    NullGeometry = 11,
    ValidGeometry = 12,
    PolygonMinimumArea = 13,
    MultiPart = 14,
    SpatialTestAll = 15,
    Checkdomain = 16,
    LogicRelShouldExist = 17,
    LineSegmentLength = 18,
    PolygonDigitizeOrder = 19,
    LineMinimumLength = 20,
    NoDoubleVertices = 21,
    PolygonSliver = 22,
    SpatialTestAllSimilarPairs = 23,
    SnappingTolerance = 24,
    LineNoCrossing = 25,
    NoIdenticalSegements = 26,
    DonutPolygon = 27,
    CoordinatesInFlanders = 28,
    DistancePoint = 29,
}

export interface GeckoStandardTestParameterTypeDto {
    name?: string;
    dataType?: GeckoStandardTestParameterDataType;
    required?: boolean;
    defaultValue?: string | null;
    label?: string | null;
}

export enum GeckoStandardTestParameterDataType {
    String = 0,
    Integer = 1,
    Decimal = 2,
    AttributesList = 3,
}

export interface CreateOperationEntityDto {
    operationSpecificationId: number;
    code: string;
    label: string;
    description: string;
    crs: string;
    modelId: number;
}

export interface UpdateOperationEntityDto {
    code: string;
    label: string;
    description: string;
    crs: string;
    modelId: number;
}

export interface OperationEntityDataMappingDetailDto {
    id?: number;
    fromEntity?: OperationEntityDetailDto | null;
    toEntity?: OperationEntityDetailDto | null;
    attributeMappings?: (OperationEntityDataAttributeMappingDto | null)[] | null;
}

export interface OperationEntityDataAttributeMappingDto {
    id?: number;
    fromAttribute?: EntityAttributeDetailDto | null;
    toAttribute?: EntityAttributeDetailDto | null;
}

export interface CreateOperationEntityDataMappingDto {
    deliveryProcessDefinitionId?: number;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: CreateOperationEntityDataAttributeMappingDto[] | null;
}

export interface CreateOperationEntityDataAttributeMappingDto {
    id?: number | null;
    fromAttributeId?: number;
    toAttributeId?: number;
}

export interface UpdateOperationEntityDataMappingDto {
    deliveryProcessDefinitionId?: number;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: CreateOperationEntityDataAttributeMappingDto[] | null;
}

export interface OperationSpecificationDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    schema?: string | null;
}

export interface CreateOperationSpecificationDto {
    deliveryProcessDefinitionId: number;
    label: string;
    description: string;
    schema: string;
}

export interface UpdateOperationSpecificationDto {
    label: string;
    description: string;
    schema: string;
}

export interface DatatableDtoOfOrganisationSearchResultDto {
    items?: OrganisationSearchResultDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface OrganisationSearchResultDto {
    id?: number;
    name?: string | null;
    ovoNumber?: string | null;
    kboNumber?: string | null;
}

export interface OrganisationDetailDto {
    id?: number;
    name?: string | null;
    kboNumber?: string | null;
    ovoNumber?: string | null;
    allowPublication?: boolean;
}

export interface UpdateOrganisationDto {
    name: string;
    ovoNumber?: string | null;
    kboNumber?: string | null;
    allowPublication?: boolean;
}

export interface CreateOrganisationDto {
    name: string;
    ovoNumber?: string | null;
    kboNumber?: string | null;
    allowPublication?: boolean;
}

export interface PdfLicenseInfo {
    remainingVolume?: number;
    totalVolume?: number;
    product?: string | null;
    type?: string | null;
    expireDate?: Date | null;
}

export interface DatatableDtoOfProcessTriggerSearchResultDto {
    items?: ProcessTriggerSearchResultDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface ProcessTriggerSearchResultDto {
    id?: number;
    triggerType?: EnumerationDto;
    description?: string | null;
    schedule?: string | null;
    deliveryProcessDefinition?: DeliveryProcessDefinitionBasicDto | null;
    productProcessDefinition?: ProductProcessDefinitionBasicDto | null;
    isEnabled?: boolean;
}

export interface ProcessTriggerDetailDto {
    id?: number;
    triggerType?: EnumerationDto | null;
    description?: string | null;
    schedule?: string | null;
    deliveryProcessDefinition?: DeliveryProcessDefinitionBasicDto | null;
    productProcessDefinition?: ProductProcessDefinitionBasicDto | null;
    job?: string | null;
    triggerDeliveryProcessDefinition?: DeliveryProcessDefinitionBasicDto | null;
    triggerProductProcessDefinition?: ProductProcessDefinitionBasicDto | null;
    isEnabled?: boolean;
    cronDescription?: string | null;
    triggerSource?: EnumerationDto | null;
}

export interface UpdateProcessTriggerDto {
    triggerType: string;
    description: string;
    schedule?: string | null;
    job?: string | null;
    deliveryProcessDefinitionId?: number | null;
    productProcessDefinitionId?: number | null;
    triggerDeliveryProcessDefinitionId?: number | null;
    triggerProductProcessDefinitionId?: number | null;
    triggerSource?: string | null;
    isEnabled?: boolean;
}

export interface CreateProcessTriggerDto {
    triggerType: string;
    description: string;
    schedule?: string | null;
    job?: string | null;
    deliveryProcessDefinitionId?: number | null;
    productProcessDefinitionId?: number | null;
    triggerDeliveryProcessDefinitionId?: number | null;
    triggerProductProcessDefinitionId?: number | null;
    triggerSource?: string | null;
    isEnabled?: boolean;
}

export interface ProcessTriggerStatusDto {
    isRunning?: boolean;
    startedOn?: Date | null;
}

export interface ProductEntityDetailDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    model?: EntityModelLinkDto | null;
    crs?: CrsDto | null;
}

export interface CreateProductEntityDto {
    productSpecificationId: number;
    code: string;
    label: string;
    description: string;
    crs: string;
    modelId: number;
}

export interface UpdateProductEntityDto {
    code: string;
    label: string;
    description: string;
    crs: string;
    modelId: number;
}

export interface ProductEntityDataMappingDetailDto {
    id?: number;
    fromEntity?: ProductEntityDetailDto | null;
    toEntity?: ProductEntityDetailDto | null;
    attributeMappings?: (ProductEntityDataAttributeMappingDto | null)[] | null;
}

export interface ProductEntityDataAttributeMappingDto {
    id?: number;
    fromAttribute?: EntityAttributeDetailDto | null;
    toAttribute?: EntityAttributeDetailDto | null;
}

export interface CreateProductEntityDataMappingDto {
    productProcessDefinitionId?: number;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: CreateProductEntityDataAttributeMappingDto[] | null;
}

export interface CreateProductEntityDataAttributeMappingDto {
    id?: number | null;
    fromAttributeId?: number;
    toAttributeId?: number;
}

export interface UpdateProductEntityDataMappingDto {
    productProcessDefinitionId?: number;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: CreateProductEntityDataAttributeMappingDto[] | null;
}

export interface ProductEntityLinkDetailDto {
    id?: number;
    fromEntity?: ProductEntityDetailDto | null;
    toEntity?: ProductEntityDetailDto | null;
    attributeMappings?: (ProductEntityLinkAttributeMappingDto | null)[] | null;
    relatedSelection?: boolean;
}

export interface ProductEntityLinkAttributeMappingDto {
    linkId?: number;
    fromAttribute?: EntityAttributeDetailDto | null;
    toAttribute?: EntityAttributeDetailDto | null;
}

export interface ProductEntityLinkCreateDto {
    specificationId?: number;
    fromEntityId?: number;
    toEntityId?: number;
    fromAttributeId?: number;
    toAttributeId?: number;
    relatedSelection?: boolean;
}

export interface ProductEntityLinkUpdateDto {
    fromEntityId?: number;
    toEntityId?: number;
    productEntityAttributeLinkId?: number;
    fromAttributeId?: number;
    toAttributeId?: number;
    relatedSelection?: boolean;
}

export interface DatatableDtoOfProductGroupSearchResultDto {
    items?: ProductGroupSearchResultDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface ProductGroupSearchResultDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    productProcessDefinitionCount?: number;
    emailCount?: number;
}

export interface ProductGroupDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    emails?: ProductGroupEmailDto[] | null;
    productProcessDefinitions?: ProductGroupMemberDto[] | null;
}

export interface ProductGroupEmailDto {
    id?: number;
    emailAddress?: string | null;
}

export interface ProductGroupMemberDto {
    id?: number;
    productProcessDefinitionId?: number;
    dataConnectionCode?: string | null;
    switchDependency?: boolean;
    productProcessDefinition?: ProductProcessDefinitionBasicDto | null;
}

export interface ProductGroupUpdateDto {
    label: string;
    description?: string | null;
    emails?: string[] | null;
    productProcessDefinitions?: ProductGroupMemberUpdateDto[] | null;
}

export interface ProductGroupMemberUpdateDto {
    productProcessDefinitionId?: number;
    switchDependency?: boolean;
}

export interface ProductGroupSelectableDefinitionDto {
    id?: number;
    label?: string | null;
    dataConnectionCode?: string | null;
}

export interface ProductGroupCreateDto {
    label: string;
    description?: string | null;
    emails?: string[] | null;
    productProcessDefinitions?: ProductGroupMemberCreateDto[] | null;
}

export interface ProductGroupMemberCreateDto {
    productProcessDefinitionId?: number;
    switchDependency?: boolean;
}

export interface ProductProcessDefinitionSearchResultDto {
    id?: number;
    label?: string | null;
    organisation?: string | null;
    ovoNumber?: string | null;
    deliveryProcessDefinition?: DeliveryProcessDefinitionBasicDto | null;
    statusId?: number;
}

export interface DatatableDtoOfProductProcessDefinitionSearchResultDto {
    items?: ProductProcessDefinitionSearchResultDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface ProductProcessDefinitionDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    organisation?: string | null;
    ovoNumber?: string | null;
    deliveryProcessDefinition?: DeliveryProcessDefinitionProductDto | null;
    statusId?: number;
    parent?: ProductProcessDefinitionBasicDto | null;
}

export interface DeliveryProcessDefinitionProductDto {
    id?: number;
    label?: string | null;
    defaultScheme?: string | null;
}

export interface ProductProcessDefinitionCreateDto {
    label?: string | null;
    description?: string | null;
    ovoNumber?: string | null;
    deliveryProcessDefinitionId?: number;
}

export interface ProductProcessDefinitionUpdateDto {
    label?: string | null;
    description?: string | null;
    ovoNumber?: string | null;
    deliveryProcessDefinitionId?: number;
}

export interface ProductProcessDefinitionDuplicationOptionsDto {
    duplicateEntityModels?: boolean;
    duplicateDeliveryProcessDefinition?: boolean;
    duplicateDeliveryQualityChecks?: boolean;
    deliveryDefinitionId?: number | null;
    disableClearMappersAfterRun?: boolean;
}

export interface ProductProcessDefinitionExportOptionsDto {
    includeDeliveryProcessDefinition?: boolean;
}

export interface ProductProcessDefinitionCascadeDeleteOptionsDto {
    deleteEntityModels?: boolean;
}

export interface ProductProcessDefinitionDependenciesReportDto {
    processTriggers?: ProcessTriggerBasicDto[];
    productProcessDefinitions?: ProductProcessDefinitionBasicDto[];
    productRuns?: ProductRunBasicDto[];
    productGroups?: ProductGroupBasicDto[];
}

export interface ProductRunBasicDto {
    id?: number;
    status?: ProductRunBasicStatusDto;
    isFailed?: boolean;
    isDryRun?: boolean;
}

export interface ProductRunBasicStatusDto {
    description?: string;
    executionDate?: Date | null;
}

export interface ProductGroupBasicDto {
    id?: number;
    label?: string | null;
}

export interface ProductProcessDefinitionReportingOptionsDto {
}

export interface DatatableDtoOfSearchProductSpecificationDto {
    items?: SearchProductSpecificationDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface SearchProductSpecificationDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    definitionId?: number | null;
}

export interface ProductSpecificationDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
    dataConnection?: DataConnectionDto | null;
    schema?: string | null;
    isMetadataContinuous?: boolean;
    baseMetadataUuid?: string | null;
    skipMapping?: boolean;
    skipMetadataPublication?: boolean;
}

export interface CreateProductSpecificationDto {
    productProcessDefinitionId: number;
    label: string;
    description: string;
    dataConnectionId: number;
    schema: string;
    baseMetadataUuid?: string | null;
    skipMapping?: boolean;
    skipMetadataPublication?: boolean;
    isMetadataContinuous?: boolean;
}

export interface UpdateProductSpecificationDto {
    label: string;
    description: string;
    dataConnectionId: number;
    schema: string;
    baseMetadataUuid?: string | null;
    skipMapping?: boolean;
    skipMetadataPublication?: boolean;
    isMetadataContinuous?: boolean;
}

export interface FeatureCatalogOptionsDto {
}

export interface ProductTransformationDetailDto {
    id?: number;
    transformationType?: TransformationTypeDto | null;
    fromEntity?: SourceEntityDetailDto | null;
    toEntity?: ProductEntityDetailDto | null;
    lookupLink?: ProductTransformationLookupLinkDetailDto | null;
    attributeMappings?: (ProductTransformationAttributeMappingDto | null)[] | null;
    parameter?: string | null;
}

export interface SourceEntityDetailDto {
    id?: number;
    code?: string | null;
    label?: string | null;
    description?: string | null;
    model?: EntityModelLinkDto | null;
    crs?: CrsDto | null;
    dataConnection?: DataConnectionDto | null;
    schema?: string;
}

export interface ProductTransformationLookupLinkDetailDto {
    id?: number;
    sourceEntity?: SourceEntityDetailDto;
    keyAttribute?: EntityAttributeDetailDto;
    valueAttribute?: EntityAttributeDetailDto;
}

export interface ProductTransformationAttributeMappingDto {
    id?: number;
    fromAttribute?: EntityAttributeDetailDto | null;
    toAttribute?: EntityAttributeDetailDto | null;
}

export interface ProductTransformationCreateDto {
    productProcessDefinitionId?: number;
    transformationType?: string | null;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: ProductTransformationAttributeMappingUpdateDto[] | null;
    lookupLinkId?: number | null;
    parameter?: string | null;
}

export interface ProductTransformationAttributeMappingUpdateDto {
    id?: number;
    fromAttributeId?: number;
    toAttributeId?: number;
}

export interface ProductTransformationUpdateDto {
    productProcessDefinitionId?: number;
    transformationType?: string | null;
    fromEntityId?: number | null;
    toEntityId?: number | null;
    attributeMappings?: ProductTransformationAttributeMappingUpdateDto[] | null;
    lookupLinkId?: number | null;
    parameter?: string | null;
}

export interface ProductTransformationLookupLinkCreateDto {
    sourceEntityId?: number;
    keyAttributeId?: number;
    valueAttributeId?: number;
}

export interface ProductTransformationLookupLinkUpdateDto {
    sourceEntityId?: number;
    keyAttributeId?: number;
    valueAttributeId?: number;
}

export interface SourceEntityCreateDto {
    sourceSpecificationId: number;
    code: string;
    label: string;
    description: string;
    crs: string;
    modelId: number;
    dataConnectionId: number;
    schema: string;
}

export interface SourceEntityUpdateDto {
    code: string;
    label: string;
    description: string;
    crs: string;
    modelId: number;
    dataConnectionId: number;
    schema: string;
}

export interface SourceSpecificationDetailDto {
    id?: number;
    label?: string | null;
    description?: string | null;
}

export interface SourceSpecificationCreateDto {
    productProcessDefinitionId: number;
    label: string;
    description: string;
}

export interface SourceSpecificationUpdateDto {
    label: string;
    description: string;
}

export interface SystemTablesDto {
    dataConnections?: (DataConnectionDto | null)[];
    contextTypes?: ContextTypeDto[];
    dataTypes?: DataTypeDto[];
    entityTypes?: EntityTypeDto[];
    formatTypes?: FormatTypeDto[];
    sridTypes?: CrsDto[];
    transformationTypes?: TransformationTypeDto[];
    triggerTypes?: TriggerTypeDto[];
    triggerSources?: TriggerSourceDto[];
    teamMembers?: TeamMemberDto[];
}

export interface ContextTypeDto {
    id?: number;
    name?: string;
}

export interface DataTypeDto {
    id?: number;
    name?: string;
}

export interface EntityTypeDto {
    id?: number;
    name?: string;
}

export interface TriggerTypeDto {
    id?: number;
    name?: string;
}

export interface TriggerSourceDto {
    id?: number;
    name?: string;
}

export interface TeamMemberDto {
    id?: number;
    name?: string;
    emailAddress?: string;
    allowMail?: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}